import { ITourElement } from "@interfaces";
import { getDisplayPriceWithOriginal } from "@utilities";

export const SearchProductPriceMessage = (faresPrices: ITourElement["faresprices"]) => {
    return getDisplayPriceWithOriginal(faresPrices || []);
};
